<w-page mode="pseudo-page" [icon]="$attachmentIcon()" [title]="$attachmentTitle()" (close)="onClose()" [headerSize]="'small'" [hideFooter]="true">

    <ng-container *w-page-header-actions>
        @if($showDownload()) {
            <w-button [iconLeft]="downloadIcon" label="Download" (onClick)="downloadFile()" />
        }
    </ng-container>

    <ng-container *w-page-body-content>
        <attachments [mode]="AttachmentsDisplayMode.Carousel" [gridGap]="0" [attachments]="$attachments()" [attachmentId]="$attachmentId()" (itemClicked)="onAttachmentSelected($event)" />
    </ng-container>

</w-page>
